// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2YYLH","actionsCol":"EnrolledClinics_actionsCol__6tLvD"};